module.exports = __webpack_public_path__ + "media/images/night-life-65477049a243de390c90cc058ff41402.jpg";